import React from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import BiddingDetailsDrawer from 'components/BiddingDetailsDrawer';
import CategoryDetailsDrawer from './components/CategoryDetailsDrawer';
import OrderDetailsDrawer from './components/OrderDetailsDrawer';
import StaffDetailsDrawer from './components/StaffDetailsDrawer';
import VendorDetailsDrawer from './components/VendorDetailsDrawer';
import InvoiceDetailsDrawer from './components/InvoiceDetailsDrawer';
import UserDetailsDrawer from './components/UserDetailsDrawer';

const Drawers = () => {
  return (
    <ErrorBoundary>
      <BiddingDetailsDrawer />
      <CategoryDetailsDrawer />
      <InvoiceDetailsDrawer />
      <OrderDetailsDrawer />
      <StaffDetailsDrawer />
      <UserDetailsDrawer />
      <VendorDetailsDrawer />
    </ErrorBoundary>
  );
};

export default Drawers;
